<li data-username="mantis dashboard" class="nav-item coded-hasmenu" [routerLinkActive]="['active']">
  <a [routerLinkActive]="['active']" (click)="navCollapse($event)">
    @if (item.icon) {
      <span class="coded-micon">
        <i antIcon type="{{ item.icon }}" theme="outline"></i>
      </span>
    }
    <span class="coded-mtext">
      {{ item.title }}
    </span>
  </a>
  <ul class="coded-submenu" [routerLinkActive]="['active']" [ngClass]="item.classes!">
    @for (item of item.children; track item) {
      @if (item.type === 'item') {
        <app-nav-item [item]="item" ></app-nav-item>
      } @else if (item.type === 'collapse') {
        <app-nav-collapse [item]="item"></app-nav-collapse>
      }
    }
  </ul>
</li>
